import { ModelSagres } from "@/types/model-sagres";

export class AnexoEdital extends ModelSagres {
    IdAnexo: number;
    IdTipoAnexo: number;
    NomeAnexo: string;
    DsDetalhes: string | null;
    PathArquivo?: string;
    CPFUsuario?: string;
    CPFUsuarioExclusao?: string;
    IdTipoAnexoNavigation: {
        IdTipoAnexo: number;
        DsTipoAnexo: string;
        FlObrigatorio: boolean;
        FlPermiteMultiplos: boolean;
        NrOrdem: number | null;
        DsTipoEdital: string | null;
        TpGrupoAnexo: "CAD"
    };

    constructor(obj?: any) {
        super();

        if (obj) {

            this.IdAnexo = obj.IdAnexo;
            this.IdTipoAnexo = obj.IdTipoAnexo;
            this.NomeAnexo = obj.NomeAnexo;
            this.DsDetalhes = obj.DsDetalhes;
            this.PathArquivo = obj.PathArquivo;
            this.CPFUsuario = obj.CPFUsuario;
            this.CPFUsuarioExclusao = obj.CPFUsuarioExclusao;
            this.IdTipoAnexoNavigation = {
                IdTipoAnexo: obj.IdTipoAnexoNavigation?.IdTipoAnexo,
                DsTipoAnexo: obj.IdTipoAnexoNavigation?.DsTipoAnexo,
                FlObrigatorio: obj.IdTipoAnexoNavigation?.FlObrigatorio,
                FlPermiteMultiplos: obj.IdTipoAnexoNavigation?.FlPermiteMultiplos,
                NrOrdem: obj.IdTipoAnexoNavigation?.NrOrdem,
                DsTipoEdital: obj.IdTipoAnexoNavigation?.DsTipoEdital,
                TpGrupoAnexo: obj.IdTipoAnexoNavigation?.TpGrupoAnexo
            };
        }
    }
}

